import { translate } from '@/domains/core/localization/translate';
export const {
  productWarranty,
  productEan,
  productRef,
  manufacturerSKU,
  brand,
  mmId
} = translate({
  "productWarranty": "Warranty",
  "productEan": "EAN",
  "productRef": "ManoMano Reference",
  "manufacturerSKU": "Product code",
  "brand": "Brand",
  "mmId": "MMID"
});